module.exports = __webpack_public_path__ + "img/vip-4.d7b7160c.png";